import React from "react";

import ConfirmDialog from "modules/common/components/dialogs/confirmDialog";
import { DISCARD_BTN_TEXT, DRAFT_CHANGED_BTN_TEXT } from "modules/common/components/authoring/constants";
import { ContentType } from "modules/common/models";

interface IDiscardDraftConfirmDialogProps {
    contentType: ContentType.Event | ContentType.Post;
    open: boolean;
    onClose: () => void;
    onSaveChanges: () => void;
    onDiscard: () => void;
}

const DiscardDraftConfirmDialog: React.FunctionComponent<IDiscardDraftConfirmDialogProps> = ({
    contentType,
    open,
    onClose,
    onSaveChanges,
    onDiscard
}) => (
    <ConfirmDialog
        title={`Discard ${contentType === ContentType.Event ? "Event" : "Post"}`}
        confirmLabel={DRAFT_CHANGED_BTN_TEXT}
        denyLabel={DISCARD_BTN_TEXT}
        open={open}
        onClose={onClose}
        onConfirm={onSaveChanges}
        onDeny={onDiscard}
    >
        You have unsaved changes to your draft. Would you like to save these changes before exiting?
    </ConfirmDialog>
);

export default DiscardDraftConfirmDialog;
